import { usePermissions } from "../../../session/permissions";

export interface SourcePermissions {
  /** Edit chunks, access, restore versions (`knowledge.edit`). */
  edit: boolean;
  /** Replace file = new upload (`knowledge.create`). */
  replace: boolean;
  reindex: boolean;
  remove: boolean;
}

/** Workspace page: a grant on any scope shows the control; the API enforces the exact scope. */
export function useSourcePermissions(): SourcePermissions {
  const permissions = usePermissions();
  const writable = !permissions.readOnly;
  const has = (key: "knowledge.edit" | "knowledge.create" | "knowledge.reindex" | "knowledge.delete") => writable && permissions.can(key, { anywhere: true });
  return { edit: has("knowledge.edit"), replace: has("knowledge.create"), reindex: has("knowledge.reindex"), remove: has("knowledge.delete") };
}
